import appReducers from '../reducer/app';
import iamReducers from "../reducer/iam";
import contentReducers from "../reducer/content";
import applicationDraftReducers from "../reducer/applicationDraft";
import inboxReducers from "../reducer/inbox";
import markApplicationReducers from "../reducer/markApplication";
import renewalApplicationReducers from "../reducer/renewalApplication";
import applicationHistoryReducers from "../reducer/applicationHistory";
import utilReducers from "../reducer/util";

const rootReducer = {
    ...appReducers,
    ...iamReducers,
    ...contentReducers,
    ...applicationDraftReducers,
    ...inboxReducers,
    ...markApplicationReducers,
    ...renewalApplicationReducers,
    ...applicationHistoryReducers,
    ...utilReducers
};

export default rootReducer;
